import React from 'react';
import { parse } from 'qs';

const parseQueryParams = ({ search }) => {
  return parse((search || '').indexOf('?') === 0 ? search.substr(1) : search);
};

const withQuery = Component => props => {
  // eslint-disable-next-line react/prop-types
  const { location, ...rest } = props;
  return (
    <Component
      {...{
        ...rest,
        location: {
          ...location,
          query: parseQueryParams(location),
        },
      }}
    />
  );
};

export default withQuery;



// WEBPACK FOOTER //
// ./src/common/components/withQuery/index.js